<template>
    <div style="background: white">
        <vue-code-setting :add="true" named v-model="newComponent" @open="openCreateDialog" @input="save" />
        <v-list>
            <vue-code-setting :add="false" named :value="component" @input="save" @remove="remove" v-for="component in $root.siteconfig.ownComponents" :key="component.id">
                <template #activator="{show}">
                    <v-list-item  @click.stop="show">
                        <div class="black--text"><v-icon>{{component.icon}}</v-icon> {{component.name}}</div>
                    </v-list-item>
                </template>
            </vue-code-setting>
        </v-list>
    </div>
</template>

<script>
import VueCodeSetting from './VueCodeSetting.vue'
import Vue from 'vue'
import components from '../component.js'

export default {
    name: 'zoezi-own-components-list',

    components: {
        VueCodeSetting
    },

    data: () => ({
        newComponent: {
            name: '',
            html: '',
            js: '',
            css: ''
        },
        newComponentProps: {
            name: 'Ny komponent',
            html:
                `<v-btn color="primary" @click="inc">
    {{text}} ({{count}})
</v-btn>
`,
            js:
                `export default {
    props: {
        text: {
            title: 'Knapptext',
            type: String,
            default: 'Klicka här'
        }
    },
    data: () => ({
        count: 1
    }),
    methods: {
        inc() {
            this.count++;
        }
    }
}`,
            css: ''
        }
    }),

    methods: {
        openCreateDialog() {
            this.newComponent = Object.assign({}, {name: this.newComponentProps.name, html: this.newComponentProps.html, js: this.newComponentProps.js, css: this.newComponentProps.css})
        },
        save(c) {
            if (!c.name) {
                return;
            }

            if (!this.$root.siteconfig.ownComponents) {
                // FIXME: This doesn't seem needed as it's done in main.js
                Vue.set(this.$root.siteconfig, 'ownComponents', {})
            }

            this.$root.siteconfig.ownComponents[c.id] = c;
            this.$root.saveHomePage();
            components.updateOwnComponents(this.$root.siteconfig);
            components.updateAllLiveComponents(c.id);
        },
        remove(c) {
            Vue.delete(this.$root.siteconfig.ownComponents, c.id);
            this.$root.saveHomePage();
            components.updateOwnComponents(this.$root.siteconfig);
            components.updateAllLiveComponents(c.id);
        }
    }
}
</script>
